import React, { useEffect, useRef, useState } from 'react';
import { Cita, finalizarTemporizador } from '../../services/citasService.ts';

type Props = {
  cita: Cita;
  sesionPosId: number;
  operadorToken?: string | null;
  onFinalizada: (cita: Cita) => void;
};

export default function TemporizadorReservaPanel({ cita, sesionPosId, operadorToken, onFinalizada }: Props) {
  const [now, setNow] = useState(Date.now());
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const pending = useRef(false);
  const mounted = useRef(true);
  useEffect(() => {
    mounted.current = true;
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => { mounted.current = false; window.clearInterval(timer); };
  }, []);
  if (cita.hora_fin != null || cita.estado === 'Cancelada' || cita.estado_ejecucion === 'Cancelada' || cita.estado_ejecucion === 'Finalizada') return null;
  const inicio = new Date(`${cita.fecha_inicio}T${cita.hora_inicio}`).getTime();
  const started = Number.isFinite(inicio) && now >= inicio;
  const seconds = started ? Math.floor((now - inicio) / 1000) : 0;
  const tiempo = [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60].map(n => String(n).padStart(2, '0')).join(':');
  const finalizar = async () => {
    if (pending.current || !operadorToken || !started) return;
    pending.current = true; setSaving(true); setError('');
    try {
      const result = await finalizarTemporizador(cita.id, sesionPosId, operadorToken);
      if (mounted.current) onFinalizada({ ...cita, hora_fin: result.hora_fin, fecha_fin: result.fecha_fin, total: Number(result.total), estado_ejecucion: 'Finalizada' });
    } catch (e: any) {
      if (mounted.current) {
        const flatten = (v: any): string => typeof v === 'string' ? v : v && typeof v === 'object' ? Object.values(v).map(flatten).join(' ') : '';
        setError(flatten(e.response?.data) || e.message || 'No se pudo finalizar el temporizador.');
      }
    } finally { pending.current = false; if (mounted.current) setSaving(false); }
  };
  return <section className="att-panel" aria-label="Temporizador de reserva">
    <div className="att-panel-heading"><div><h3>Temporizador</h3><small>{started ? 'Tiempo transcurrido desde el inicio' : 'Pendiente de la hora de inicio'}</small></div></div>
    <div className="att-panel-content">
      <p style={{ fontSize: 28, fontWeight: 700, color: '#007fc8', fontVariantNumeric: 'tabular-nums', margin: '0 0 12px' }}>{tiempo}</p>
      <p>Al finalizar se registrará la salida y se calcularán el total y el saldo según la tarifa del plan.</p>
      {error && <p role="alert" className="att-error">{error}</p>}
      {!operadorToken && <p>Identifica al operador con su PIN para finalizar.</p>}
      <button className="att-button att-primary" disabled={saving || !operadorToken || !started} onClick={() => void finalizar()}>{saving ? 'Finalizando…' : 'Finalizar temporizador'}</button>
    </div>
  </section>;
}
